"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createShadow = void 0;
const polished_1 = require("polished");
const defaultShadow = {
    sm: "0 2px 4px 0 rgba(0, 0, 0, .1)",
    md: "0 5px 25px 0 rgba(0, 0, 0, .1)",
    lg: "0 20px 25px -5px rgba(0, 0, 0, .1), 0 10px 10px -5px rgba(0, 0, 0, .05)",
};
const defaultOutline = (color) => `0 0 0 ${(0, polished_1.rem)(3)} ${(0, polished_1.rgba)(color, 0.3)}`;
function createShadow(shadow = {}, outline = defaultOutline) {
    return {
        outline,
        shadow: (key) => shadow[key] || defaultShadow[key],
    };
}
exports.createShadow = createShadow;
exports.default = createShadow;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlLXNoYWRvdy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3RoZW1pbmcvY3JlYXRlLXNoYWRvdy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSx1Q0FBcUM7QUFlckMsTUFBTSxhQUFhLEdBQWlCO0lBQ2xDLEVBQUUsRUFBRSwrQkFBK0I7SUFDbkMsRUFBRSxFQUFFLGdDQUFnQztJQUNwQyxFQUFFLEVBQUUseUVBQXlFO0NBQzlFLENBQUM7QUFDRixNQUFNLGNBQWMsR0FBRyxDQUFDLEtBQVksRUFBRSxFQUFFLENBQUMsU0FBUyxJQUFBLGNBQUcsRUFBQyxDQUFDLENBQUMsSUFBSSxJQUFBLGVBQUksRUFBQyxLQUFLLEVBQUUsR0FBRyxDQUFDLEVBQUUsQ0FBQztBQUUvRSxTQUFnQixZQUFZLENBQUMsU0FBeUIsRUFBRSxFQUFFLFVBQTJCLGNBQWM7SUFDakcsT0FBTztRQUNMLE9BQU87UUFDUCxNQUFNLEVBQUUsQ0FBQyxHQUFXLEVBQUUsRUFBRSxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsSUFBSSxhQUFhLENBQUMsR0FBRyxDQUFDO0tBQzNELENBQUM7QUFDSixDQUFDO0FBTEQsb0NBS0M7QUFFRCxrQkFBZSxZQUFZLENBQUMifQ==